import { render, staticRenderFns } from "./TypeSpotFolder.vue?vue&type=template&id=11ce8396&"
import script from "./TypeSpotFolder.vue?vue&type=script&lang=js&"
export * from "./TypeSpotFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports